import { render, staticRenderFns } from "./TableListConfig.vue?vue&type=template&id=347704f5&scoped=true"
import script from "./TableListConfig.vue?vue&type=script&lang=js"
export * from "./TableListConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347704f5",
  null
  
)

export default component.exports